import React from "react";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng
} from "react-places-autocomplete";
import './places.css'

function Places(props) {

    const {setPlace, place} = props

    const [address, setAddress] = React.useState("");


    const handleSelect = async value => {
        const results = await geocodeByAddress(value);
        const latLng = await getLatLng(results[0]);
        setAddress(value);
        setPlace({...place, latitude: latLng.lat, longitude: latLng.lng, zoom: 14})
    };

    return (
        <div >
            <PlacesAutocomplete
                value={address}
                onChange={setAddress}
                onSelect={handleSelect}
                googleCallbackName="initOne"
            >
                {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                    <div className="places-container">
                        <input {...getInputProps({placeholder: "Buscar direccion"})} className="places-input"/>
                        <div className={'result-autocomplete-container'}>
                            {loading ? <div>...Cargando</div> : null}
                            {suggestions.map((suggestion, i) => {
                                return (
                                    <div {...getSuggestionItemProps(suggestion)} key={i}
                                         className={'result-autocomplete-container'}>
                                        <span className="places-result-span">
                                             {suggestion.description}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
        </div>
    );
}

export default Places
